import React from 'react';
import {
  f7,
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col,
  Checkbox,
  Preloader,
} from 'framework7-react';

import { PrimaryLogo, MerchantSvg, BikeSvg } from '../components/crumbs';

// _helper
import {
  toast,
  isEmpty,
  isValidEmail,
  uploadFile,
  reverseGeocoding,
  handleErrors,
  deleteFiles,
  generateId,
  isAllowedVendorsAndAgents,
} from '../utils/_helpers';
import { Doc } from '../utils/_classes';
import countries from '../static/countries.json';
import cities from '../static/ng.json';

import BusinessMap from '../components/BusinessMap';
import useGeoCode from '../utils/geoCode';

// Redux
import { compose } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { withFirestore, withStorage, firestoreConnect } from '../HOCs';

class BusinessRegistration extends React.Component {
  constructor(props) {
    super(props);
    var signupForm = props.f7route.params.id;

    this.state = {
      popupOpened: false,
      popupDataChanged: true,
      countries,
      maps: null,
      type: signupForm,
      which:
        signupForm === '1'
          ? 'merchantRegistrationInfo'
          : signupForm === '2'
          ? 'deliveryRegistrationInfo'
          : signupForm === '3'
          ? 'partnerRegistrationInfo'
          : null,
      file: 'static/icon-512x512@1x.png',
      file1: 'static/icon-512x512@1x.png',
      file2: 'static/icon-512x512@1x.png',
      registrationType: signupForm === '3' ? 'Personal' : 'Business',

      referralAgentId: '',
      showReferralError: false,
      referralErrorClass: 'success',

      merchantRegistrationInfo: {
        businessLogo: null,
        certificate1: null,
        certificate2: null,
        businessProfile: {
          slogan: '',
          geoLoc: {
            lat: '',
            lng: '',
          },
          name: '',
          address: '',
          phone: '',
          email: '',
          country: 'Nigeria',
          state: '',
          city: '',
          category: 'Food',
          ownsDelivery: 'No',
          operationStartTime: '6 am',
          operationCloseTime: '6 pm',
        },
      },

      deliveryRegistrationInfo: {
        businessLogo: null,
        certificate1: null,
        certificate2: null,
        businessProfile: {
          slogan: '',
          geoLoc: {
            lat: '',
            lng: '',
          },
          name: '',
          address: '',
          phone: '',
          email: '',
          country: 'Nigeria',
          state: '',
          city: '',
          category: 'Buses',
          discovery: [],
          fleetNumber: '',
          operationStartTime: '6 am',
          operationCloseTime: '6 pm',
        },
      },

      partnerRegistrationInfo: {
        businessLogo: null,
        certificate2: null,
        businessProfile: {
          geoLoc: {
            lat: '',
            lng: '',
          },
          name: '',
          address: '',
          phone: '',
          email: '',
          country: 'Nigeria',
          state: '',
          city: '',
          employed: 'No',
          spokenLanguages: {
            english: true,
            french: false,
            hausa: false,
            igbo: false,
            yoruba: false,
            others: '',
          },
          partnerType: 'Referral',
          referralId: generateId(7),
        },
      },

      images: {},

      registrationButton: 'Submit Application',
      operatingTime: [
        '12 am',
        '1 am',
        '2 am',
        '3 am',
        '4 am',
        '5 am',
        '6 am',
        '7 am',
        '8 am',
        '9 am',
        '10 am',
        '11 am',
        '12 pm',
        '1 pm',
        '2 pm',
        '3 pm',
        '4 pm',
        '5 pm',
        '6 pm',
        '7 pm',
        '8 pm',
        '9 pm',
        '10 pm',
        '11 pm',
      ],
    };

    this.selectedLanguages = this.selectedLanguages.bind(this);
  }

  fetchPlaces(mapProps, map) {
    const self = this;
    const { google } = mapProps;
    self.setState({
      ...self.state,
      maps: google.maps,
    });

    const input = document.querySelector('#business_address input');
    self.autocomplete = new google.maps.places.Autocomplete(input);
    self.autocomplete.setFields(['formatted_address', 'geometry', 'name']);
    self.autocomplete.bindTo('bounds', map);
    self.autocomplete.addListener('place_changed', () => {
      let response = self.autocomplete.getPlace();
      if (!response.geometry) {
        this.setState({
          ...this.state,
          [this.state.which]: {
            ...this.state[this.state.which],
            businessProfile: {
              ...this.state[this.state.which].businessProfile,
              address: '',
            },
          },
        });

        return toast(self.$f7.toast, {
          text: `No details available for input: ${response.name}. Please make sure you select a suggestted place`,
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      if (response) {
        this.setState({
          ...this.state,
          [this.state.which]: {
            ...this.state[this.state.which],
            businessProfile: {
              ...this.state[this.state.which].businessProfile,
              address: response.name,
              geoLoc: {
                lat: response.geometry.location.lat(),
                lng: response.geometry.location.lng(),
              },
            },
          },
        });
      }
    });
  }

  moveMarker(props, marker, e) {
    this.setState({
      ...this.state,
      [this.state.which]: {
        ...this.state[this.state.which],
        businessProfile: {
          ...this.state[this.state.which].businessProfile,
          geoLoc: {
            lat: marker.position.lat(),
            lng: marker.position.lng(),
          },
        },
      },
    });

    useGeoCode(
      {
        type: 'Address',
        data: {
          lat: marker.position.lat(),
          lng: marker.position.lng(),
        },
      },
      (error, result) => {
        if (error) {
          return this.setState({
            ...this.state,
            [this.state.which]: {
              ...this.state[this.state.which],
              businessProfile: {
                ...this.state[this.state.which].businessProfile,
                address: '',
              },
            },
          });
        }

        this.setState({
          ...this.state,
          [this.state.which]: {
            ...this.state[this.state.which],
            businessProfile: {
              ...this.state[this.state.which].businessProfile,
              address: result,
            },
          },
        });
      }
    );
  }

  onMapClicked(mapProps, map, clickEvent) {
    this.setState({
      ...this.state,
      [this.state.which]: {
        ...this.state[this.state.which],
        businessProfile: {
          ...this.state[this.state.which].businessProfile,
          geoLoc: {
            lat: clickEvent.latLng.lat(),
            lng: clickEvent.latLng.lng(),
          },
        },
      },
    });

    useGeoCode(
      {
        type: 'Address',
        data: {
          lat: clickEvent.latLng.lat(),
          lng: clickEvent.latLng.lng(),
        },
      },
      (error, result) => {
        if (error) {
          return this.setState({
            ...this.state,
            [this.state.which]: {
              ...this.state[this.state.which],
              businessProfile: {
                ...this.state[this.state.which].businessProfile,
                address: '',
              },
            },
          });
        }
        this.setState({
          ...this.state,
          [this.state.which]: {
            ...this.state[this.state.which],
            businessProfile: {
              ...this.state[this.state.which].businessProfile,
              address: result,
            },
          },
        });
      }
    );
  }

  // show map function
  showMap() {
    const self = this;
    if ('geolocation' in navigator) {
      if (f7.device.cordova) {
        document.addEventListener(
          'deviceready',
          self.onDeviceReady.bind(this),
          false
        );
      } else {
        self.onDeviceReady();
      }
    } else {
      f7.dialog.alert(
        `This device does not support geolocation. Please use the autocomplete on the address field`,
        'Location Error'
      );
    }
  }

  // handle map display when component loads
  onDeviceReady() {
    const self = this;
    navigator.geolocation.getCurrentPosition(
      (position) => {
        self.setState({
          ...self.state,
          [self.state.which]: {
            ...self.state[self.state.which],
            businessProfile: {
              ...self.state[self.state.which].businessProfile,
              geoLoc: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
          },
        });

        useGeoCode(
          {
            type: 'Address',
            data: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
          },
          (error, result) => {
            if (error) {
              return self.setState({
                ...self.state,
                [self.state.which]: {
                  ...self.state[self.state.which],
                  businessProfile: {
                    ...self.state[self.state.which].businessProfile,
                    address: '',
                  },
                },
              });
            }

            self.setState({
              ...self.state,
              [self.state.which]: {
                ...self.state[self.state.which],
                businessProfile: {
                  ...self.state[self.state.which].businessProfile,
                  address: result,
                },
              },
            });
          }
        );
      },
      (error) => {
        const generalText = 'Please use the autocomplete on the address field';
        const text =
          error.code === 1
            ? `You have denied us access to your location. ${generalText}`
            : error.code === 2
            ? `An error occured while getting your geolocation. ${generalText}`
            : `Fetching location timed out. ${generalText}`;
        f7.dialog.alert(text, 'Location Error');
      },
      { maximumAge: 3000, timeout: 5000, enableHighAccuracy: true }
    );
  }

  render() {
    return (
      <Page
        id="business-registration-page"
        onPageAfterIn={this.onPageAfterIn.bind(this)}>
        <Navbar sliding={false} backLink="Back">
          <NavTitle sliding>
            {' '}
            {this.state.type == 1
              ? 'Merchant Registration'
              : this.state.type == 2
              ? 'Delivery Agent Registration'
              : this.state.type == 3
              ? 'Easychaw Agent Registration'
              : 'Application Declined'}
          </NavTitle>
        </Navbar>

        {/* Business Registration Form */}
        <Block id="business-registration-page-forms">
          <Row>
            {/* [Card-1] Certificates */}
            <Col width="100" medium="50" style={{ marginBottom: '20pt' }}>
              <Card style={{ margin: 'auto' }}>
                <CardHeader className="no-border">
                  {this.state.registrationType} Certificates
                </CardHeader>
                <CardContent className="no-padding">
                  <Row>
                    <Col width="100">
                      <Block
                        style={{
                          backgroundImage: 'url(static/pattern-portrait.png)',
                          backgroundSize: 'cover',
                          backgroundPosition: 'bottom',
                          height: '300px',
                          display: 'flex',
                        }}>
                        <img
                          src={this.state.file}
                          style={{
                            height: '200px',
                            width: '200px',
                            margin: 'auto',
                            objectFit: 'cover',
                            boxShadow: '4px 4px 13px 0px #947c29c9',
                            borderRadius: '10px',
                          }}
                        />
                      </Block>

                      <Block
                        style={{
                          padding: '2px',
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '-20px',
                          paddingBottom: '20px',
                          borderBottom: '1px dashed #f3f3f3',
                        }}>
                        <List noHairlines noHairlinesAurora>
                          <ListInput
                            style={{
                              width: '153px',
                              textAlign: 'center',
                            }}
                            className="custom-file-input"
                            label={
                              this.state.type == 3
                                ? 'Profile Picture'
                                : 'Business Logo'
                            }
                            type="file"
                            placeholder="Please select an image"
                            info="Image formats png|jpg|jpeg"
                            required
                            validate
                            onChange={(e) => {
                              const reader = new FileReader();
                              if (reader) {
                                reader.onload = (e) => {
                                  this.setState({
                                    ...this.state,
                                    file: e.target.result,
                                  });
                                };
                                reader.readAsDataURL(e.target.files[0]);
                              }
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessLogo: e.target.files[0],
                                },
                              });
                            }}></ListInput>
                        </List>
                      </Block>
                    </Col>

                    <Col width="100">
                      <Block
                        style={
                          this.state.type == 3
                            ? { marginTop: '53px', marginBottom: '130px' }
                            : { marginTop: '53px' }
                        }>
                        <List mediaList>
                          {this.state.type != 3 ? (
                            <ListInput
                              style={{ marginTop: '10pt', marginLeft: '10px' }}
                              className="custom-file-input"
                              label="Buisness Registration Certificate"
                              type="file"
                              placeholder="Please select an image"
                              info="Image formats png|jpg|jpeg"
                              required
                              validate
                              onChange={(e) => {
                                const reader = new FileReader();
                                if (reader) {
                                  reader.onload = (e) => {
                                    this.setState({
                                      ...this.state,
                                      file1: e.target.result,
                                    });
                                  };
                                  reader.readAsDataURL(e.target.files[0]);
                                }
                                this.setState({
                                  ...this.state,
                                  [this.state.which]: {
                                    ...this.state[this.state.which],
                                    certificate1: e.target.files[0],
                                  },
                                });
                              }}>
                              <img
                                slot="media"
                                src={this.state.file1}
                                style={{
                                  width: '75px',
                                  height: '75px',
                                  marginLeft: '-13px',
                                  objectFit: 'cover',
                                }}
                              />
                            </ListInput>
                          ) : null}

                          <ListInput
                            style={{
                              marginTop: '10pt',
                              marginBottom: '20pt',
                              marginLeft: '10px',
                            }}
                            className="custom-file-input"
                            label="Upload voter id/drivers license/national id"
                            type="file"
                            placeholder="Please select an image"
                            info="Image formats png|jpg|jpeg"
                            required
                            validate
                            onChange={(e) => {
                              const reader = new FileReader();
                              if (reader) {
                                reader.onload = (e) => {
                                  this.setState({
                                    ...this.state,
                                    file2: e.target.result,
                                  });
                                };
                                reader.readAsDataURL(e.target.files[0]);
                              }
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  certificate2: e.target.files[0],
                                },
                              });
                            }}>
                            <img
                              slot="media"
                              src={this.state.file2}
                              style={{
                                width: '75px',
                                height: '75px',
                                marginLeft: '-13px',
                                objectFit: 'cover',
                              }}
                            />
                          </ListInput>
                        </List>
                      </Block>
                    </Col>
                  </Row>
                </CardContent>
              </Card>
            </Col>

            {/* [Card-3] Details */}
            <Col width="100" medium="50" style={{ marginBottom: '20pt' }}>
              <Card style={{ margin: 'auto' }}>
                <CardHeader className="no-border">
                  {this.state.registrationType} Details
                </CardHeader>
                <CardContent>
                  <Row>
                    <Col width="100">
                      <List noHairlinesMd>
                        <ListInput
                          label={`Legal ${this.state.registrationType} Name`}
                          type="text"
                          placeholder="Please enter name here"
                          info="Name required"
                          required
                          validate
                          value={
                            this.state[this.state.which].businessProfile.name
                          }
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],
                                businessProfile: {
                                  ...this.state[this.state.which]
                                    .businessProfile,
                                  name: e.target.value,
                                },
                              },
                            })
                          }
                          clearButton>
                          <Icon f7="briefcase" slot="media" />
                        </ListInput>

                        {this.state.type != 3 ? (
                          <ListInput
                            label="Business slogan"
                            type="text"
                            placeholder="Please enter slogan here"
                            info="Optional input field"
                            value={
                              this.state[this.state.which].businessProfile
                                .slogan
                            }
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessProfile: {
                                    ...this.state[this.state.which]
                                      .businessProfile,
                                    slogan: e.target.value,
                                  },
                                },
                              })
                            }>
                            <Icon f7="pencil_outline" slot="media" />
                          </ListInput>
                        ) : null}

                        <ListInput
                          label={`Legal ${this.state.registrationType} Address`}
                          type="text"
                          placeholder="Please enter address here"
                          info="Address required"
                          id="business_address"
                          required
                          validate
                          value={
                            this.state[this.state.which].businessProfile.address
                          }
                          onBlur={(e) => {
                            if (e.target.value.trim() === '') {
                              return toast(this.$f7.toast, {
                                text: `Please enter a valid address`,
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }
                          }}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],
                                businessProfile: {
                                  ...this.state[this.state.which]
                                    .businessProfile,
                                  address: e.target.value,
                                },
                              },
                            })
                          }>
                          <Icon f7="map_pin_ellipse" slot="media" />
                        </ListInput>

                        <ListInput
                          label={`${this.state.registrationType} Phone Number`}
                          type="tel"
                          placeholder="Enter number"
                          info="eg: 09030000009"
                          errorMessage="Only numbers please!"
                          required
                          validate
                          value={
                            this.state[this.state.which].businessProfile.phone
                          }
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],
                                businessProfile: {
                                  ...this.state[this.state.which]
                                    .businessProfile,
                                  phone: e.target.value,
                                },
                              },
                            })
                          }
                          pattern="[0-9]*"
                          clearButton>
                          <Icon f7="phone" slot="media" />
                        </ListInput>

                        <ListInput
                          label={`${this.state.registrationType} Email Address`}
                          type="email"
                          placeholder="Please enter e-mail address here"
                          info="Default e-mail validation"
                          required
                          validate
                          value={
                            this.state[this.state.which].businessProfile.email
                          }
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],
                                businessProfile: {
                                  ...this.state[this.state.which]
                                    .businessProfile,
                                  email: e.target.value,
                                },
                              },
                            })
                          }
                          clearButton>
                          <Icon f7="envelope" slot="media" />
                        </ListInput>

                        <ListInput
                          label="Country"
                          type="select"
                          placeholder="Please select country"
                          info="Select country from dropdown"
                          required
                          value={
                            this.state[this.state.which].businessProfile.country
                          }
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],
                                businessProfile: {
                                  ...this.state[this.state.which]
                                    .businessProfile,
                                  country: e.target.value,
                                },
                              },
                            })
                          }>
                          {this.state.countries.map((country, i) => (
                            <option key={i} value={country}>
                              {country}
                            </option>
                          ))}
                          <Icon f7="globe" slot="media" />
                        </ListInput>

                        <ListInput
                          label="State"
                          type="select"
                          placeholder="Please select state"
                          info="Select state from dropdown"
                          required
                          value={
                            this.state[this.state.which].businessProfile.state
                          }
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],
                                businessProfile: {
                                  ...this.state[this.state.which]
                                    .businessProfile,
                                  state: e.target.value,
                                },
                              },
                            })
                          }>
                          <option></option>
                          {[
                            ...new Set(
                              cities
                                .filter(
                                  (cityInfo) =>
                                    cityInfo.country ===
                                    this.state[this.state.which].businessProfile
                                      .country
                                )
                                .map((cityInfo) => cityInfo.admin_name)
                            ),
                          ]
                            .sort()
                            .map((stateName, i) => (
                              <option key={i} value={stateName}>
                                {stateName}
                              </option>
                            ))}
                          <Icon f7="globe" slot="media" />
                        </ListInput>

                        <ListInput
                          label="City"
                          type="select"
                          placeholder="Please select city"
                          info="Select city from dropdown"
                          required
                          disabled={
                            this.state[
                              this.state.which
                            ].businessProfile.state.trim() === ''
                          }
                          value={
                            this.state[this.state.which].businessProfile.city
                          }
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],
                                businessProfile: {
                                  ...this.state[this.state.which]
                                    .businessProfile,
                                  city: e.target.value,
                                },
                              },
                            })
                          }>
                          <option></option>
                          {this.state[this.state.which].businessProfile.state &&
                            [
                              ...new Set(
                                cities
                                  .filter(
                                    (cityInfo) =>
                                      cityInfo.country ===
                                        this.state[this.state.which]
                                          .businessProfile.country &&
                                      cityInfo.admin_name ===
                                        this.state[this.state.which]
                                          .businessProfile.state
                                  )
                                  .map((cityInfo) => cityInfo.city)
                              ),
                            ]
                              .sort()
                              .map((cityName, i) => (
                                <option key={i} value={cityName}>
                                  {cityName}
                                </option>
                              ))}
                          <Icon f7="globe" slot="media" />
                        </ListInput>

                        {this.state.type == 1 ? (
                          <ListInput
                            label="Business category"
                            type="select"
                            placeholder="Please select category"
                            info="Select category from dropdown"
                            required
                            validate
                            value={
                              this.state[this.state.which].businessProfile
                                .category
                            }
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessProfile: {
                                    ...this.state[this.state.which]
                                      .businessProfile,
                                    category: e.target.value,
                                  },
                                },
                              })
                            }>
                            <option>Food</option>
                            <Icon f7="layers_alt" slot="media" />
                          </ListInput>
                        ) : null}

                        {this.state.type == 2 ? (
                          <ListInput
                            label="Logistic type"
                            type="select"
                            placeholder="Please select type"
                            info="Select automobile from dropdown"
                            required
                            validate
                            value={
                              this.state[this.state.which].businessProfile
                                .category
                            }
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessProfile: {
                                    ...this.state[this.state.which]
                                      .businessProfile,
                                    category: e.target.value,
                                  },
                                },
                              })
                            }>
                            <option value="Bikes">Bikes</option>
                            <option value="Cars">Cars</option>
                            <option value="Multiple">Multiple</option>
                            <Icon f7="layers_alt" slot="media" />
                          </ListInput>
                        ) : null}

                        {this.state.type == 1 ? (
                          <ListInput
                            label="Delivery service"
                            type="select"
                            placeholder="Please select delivery"
                            info="Do you provide your own delivery?"
                            required
                            validate
                            value={
                              this.state[this.state.which].businessProfile
                                .ownsDelivery
                            }
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessProfile: {
                                    ...this.state[this.state.which]
                                      .businessProfile,
                                    ownsDelivery: e.target.value,
                                  },
                                },
                              })
                            }>
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                            <Icon f7="car_fill" slot="media" />
                          </ListInput>
                        ) : null}
                        {this.state.type == 2 ? (
                          <ListInput
                            label="Fleet number"
                            type="text"
                            placeholder="Enter number of automobiles owned"
                            info="eg: 10"
                            errorMessage="Only numbers please!"
                            required
                            validate
                            pattern="[0-9]*"
                            value={
                              this.state[this.state.which].businessProfile
                                .fleetNumber
                            }
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessProfile: {
                                    ...this.state[this.state.which]
                                      .businessProfile,
                                    fleetNumber: e.target.value,
                                  },
                                },
                              })
                            }
                            clearButton>
                            <Icon f7="car_fill" slot="media" />
                          </ListInput>
                        ) : null}
                        {this.state.type == 3 ? (
                          <ListInput
                            label="Employment status"
                            type="select"
                            placeholder="Please select yes/no"
                            info="Are you currently employed?"
                            required
                            validate
                            value={
                              this.state[this.state.which].businessProfile
                                .employed
                            }
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessProfile: {
                                    ...this.state[this.state.which]
                                      .businessProfile,
                                    employed: e.target.value,
                                  },
                                },
                              })
                            }>
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                            <Icon f7="briefcase" slot="media" />
                          </ListInput>
                        ) : null}

                        {this.state.type != 3 ? (
                          <ListInput
                            label="Business Opening Time"
                            type="select"
                            placeholder="Please select opening time"
                            info="Select time from dropdown"
                            required
                            value={
                              this.state[this.state.which].businessProfile
                                .operationStartTime
                            }
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessProfile: {
                                    ...this.state[this.state.which]
                                      .businessProfile,
                                    operationStartTime: e.target.value,
                                  },
                                },
                              })
                            }>
                            {this.state.operatingTime.map((time, i) => (
                              <option key={i} value={time}>
                                {time}
                              </option>
                            ))}
                            <Icon f7="timer" slot="media" />
                          </ListInput>
                        ) : null}

                        {this.state.type != 3 ? (
                          <ListInput
                            label="Business Closing Time"
                            type="select"
                            placeholder="Please select closing time"
                            info="Select time from dropdown"
                            required
                            value={
                              this.state[this.state.which].businessProfile
                                .operationCloseTime
                            }
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                [this.state.which]: {
                                  ...this.state[this.state.which],
                                  businessProfile: {
                                    ...this.state[this.state.which]
                                      .businessProfile,
                                    operationCloseTime: e.target.value,
                                  },
                                },
                              })
                            }>
                            {this.state.operatingTime.map((time, i) => (
                              <option key={i} value={time}>
                                {time}
                              </option>
                            ))}
                            <Icon f7="timer" slot="media" />
                          </ListInput>
                        ) : null}
                      </List>

                      {this.state.type == 3 ? (
                        <List>
                          <BlockTitle
                            style={{ marginTop: '10px', marginLeft: '16px' }}>
                            Please select fluent languages
                          </BlockTitle>

                          <ListItem>
                            English
                            <Checkbox
                              checked={
                                this.state[this.state.which].businessProfile
                                  .spokenLanguages.english
                              }
                              onChange={(e) =>
                                this.selectedLanguages(
                                  e.target.checked,
                                  'english'
                                )
                              }></Checkbox>
                          </ListItem>
                          <ListItem>
                            French
                            <Checkbox
                              checked={
                                this.state[this.state.which].businessProfile
                                  .spokenLanguages.french
                              }
                              onChange={(e) =>
                                this.selectedLanguages(
                                  e.target.checked,
                                  'french'
                                )
                              }></Checkbox>
                          </ListItem>
                          <ListItem>
                            Hausa
                            <Checkbox
                              checked={
                                this.state[this.state.which].businessProfile
                                  .spokenLanguages.hausa
                              }
                              onChange={(e) =>
                                this.selectedLanguages(
                                  e.target.checked,
                                  'hausa'
                                )
                              }></Checkbox>
                          </ListItem>
                          <ListItem>
                            Igbo
                            <Checkbox
                              checked={
                                this.state[this.state.which].businessProfile
                                  .spokenLanguages.igbo
                              }
                              onChange={(e) =>
                                this.selectedLanguages(e.target.checked, 'igbo')
                              }></Checkbox>
                          </ListItem>
                          <ListItem>
                            Yoruba
                            <Checkbox
                              checked={
                                this.state[this.state.which].businessProfile
                                  .spokenLanguages.yoruba
                              }
                              onChange={(e) =>
                                this.selectedLanguages(
                                  e.target.checked,
                                  'yoruba'
                                )
                              }></Checkbox>
                          </ListItem>

                          <ListInput
                            label="Other Languages"
                            type="text"
                            placeholder="Please fill eg: Spanish, Italian, ..."
                            info="Do you speak other languages?"
                            value={
                              this.state[this.state.which].businessProfile
                                .spokenLanguages.others
                            }
                            onChange={(e) =>
                              this.selectedLanguages(e.target.value, 'others')
                            }>
                            <Icon f7="globe" slot="media" />
                          </ListInput>
                        </List>
                      ) : null}
                    </Col>
                  </Row>
                </CardContent>
              </Card>
            </Col>

            {/* [Card-3] Map */}
            <Col width="100">
              <Card style={{ margin: 'auto' }}>
                <CardHeader className="no-border">
                  {`${this.state.registrationType}`} Map Location
                </CardHeader>
                <CardContent className="no-padding">
                  <BlockTitle>Please select exact location</BlockTitle>
                  <div
                    id="businessRegMap"
                    className="business-map"
                    style={{
                      height: '40vh',
                      position: 'relative',
                      border: '2px solid #ddd',
                      borderRadius: '6px',
                      margin: '16px',
                    }}>
                    <BusinessMap
                      center={
                        this.state[this.state.which].businessProfile.geoLoc
                          .lat !== '' &&
                        this.state[this.state.which].businessProfile.geoLoc
                          .lng !== ''
                          ? this.state[this.state.which].businessProfile.geoLoc
                          : { lat: 4.824167, lng: 7.033611 }
                      }
                      // title={
                      //   this.state[this.state.which].businessProfile.address ||
                      //   ''
                      // }
                      moveMarker={this.moveMarker.bind(this)}
                      onMapClicked={this.onMapClicked.bind(this)}
                      fetchPlaces={this.fetchPlaces.bind(this)}
                    />
                  </div>
                </CardContent>
                <CardFooter>
                  <Row style={{ width: '100%' }}>
                    {this.state.type != 3 ? (
                      <Col width="50" medium="30">
                        <Row noGap>
                          <Col width="70">
                            <List>
                              <ListInput
                                type="text"
                                maxlength="7"
                                name="referralId"
                                placeholder="Referral code"
                                value={this.state.referralAgentId}
                                disabled={
                                  this.state.referralErrorClass === 'loading'
                                }
                                onBlur={(e) => {
                                  if (
                                    e.target.value !== '' &&
                                    e.target.value.length < 7
                                  ) {
                                    this.setState({
                                      ...this.state,
                                      registrationButton: 'Submit',
                                      showReferralError: true,
                                      referralErrorClass: 'error',
                                    });
                                  }
                                }}
                                onInputEmpty={(e) =>
                                  this.setState({
                                    ...this.state,
                                    registrationButton: 'Submit Application',
                                    referralAgentId: e.target.value,
                                    showReferralError: false,
                                    referralErrorClass: '',
                                  })
                                }
                                onInput={(e) =>
                                  this.validateReferral(e.target.value)
                                }
                                className={`custom-count-input ${this.state.referralErrorClass}`}>
                                {' '}
                                {/*use .error  or .success class here */}
                              </ListInput>
                            </List>
                          </Col>
                          <Col width="30">
                            <pre
                              style={{
                                marginTop: '0px',
                                backgroundColor: '#f3f3f3',
                                textAlign: 'center',
                                padding: '8.5px 0',
                                border: '1px solid hsla(0, 0%, 90%, 1)',
                                borderTopRightRadius: '20px',
                                borderBottomRightRadius: '20px',
                              }}>
                              {this.state.referralErrorClass === 'success' ||
                              this.state.referralErrorClass === 'error' ||
                              this.state.referralErrorClass === '' ? (
                                <Icon f7="arrow_2_squarepath"></Icon>
                              ) : (
                                <Preloader size={10}></Preloader>
                              )}
                            </pre>
                          </Col>
                          <Col
                            width="100"
                            className={`${
                              this.state.showReferralError ? 'show' : 'hide'
                            }`}>
                            {' '}
                            {/*use .show  or .hide class here if referral code is invalid*/}
                            <Block className="sdab">
                              <small>
                                Referral code is invalid, please check and try
                                again.
                              </small>
                            </Block>
                          </Col>
                        </Row>
                      </Col>
                    ) : (
                      <Col>&nbsp;</Col>
                    )}

                    <Col width="50" medium="30">
                      <Button
                        round
                        fill
                        style={{
                          width: '100%',
                        }}
                        onClick={this.register.bind(this)}
                        disabled={
                          this.state.registrationButton !==
                            'Submit Application' ||
                          this.state[
                            this.state.which
                          ].businessProfile.address.trim() === ''
                        }>
                        {this.state.registrationButton}
                      </Button>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Block>
      </Page>
    );
  }

  // LifeCycle
  componentDidMount() {
    this.showMap();

    if (
      this.props.data &&
      !this.props.data.loading &&
      ((this.props.f7route.params.id == '1' &&
        this.props.data.merchants &&
        this.props.data.merchants[this.props.auth.uid]) ||
        (this.props.f7route.params.id == '2' &&
          this.props.data.delivery &&
          this.props.data.delivery[this.props.auth.uid]) ||
        (this.props.f7route.params.id == '3' &&
          this.props.data.partners &&
          this.props.data.partners[this.props.auth.uid]))
    ) {
      this.fillForm();
    }
  }

  componentWillUnmount() {
    if (this.state.maps && this.autocomplete) {
      this.state.maps.event.clearInstanceListeners(this.autocomplete);
    }
  }

  // Events
  onPageAfterIn() {
    this.$f7.methods.showFullText();
  }

  validateReferral(referralId) {
    if (referralId.length > 0 && referralId.length < 7) {
      // disable submit and show error
      this.setState({
        ...this.state,
        registrationButton: 'Submit',
        referralAgentId: referralId,
        showReferralError: false,
        referralErrorClass: '',
      });
    }

    if (referralId.length === 7) {
      // check if referral agent exists and allow submit
      this.setState({
        ...this.state,
        registrationButton: 'Submit',
        referralAgentId: referralId,
        showReferralError: false,
        referralErrorClass: 'loading',
      });

      this.props.firestore
        .collection('partners')
        .where('businessProfile.referralId', '==', referralId)
        .get()
        .then((querySnapshot) => {
          if (
            querySnapshot.size === 0 ||
            !querySnapshot.docs.find(
              (doc) => doc.data().businessProfile.referralId === referralId
            )
          ) {
            // no such agent
            this.setState({
              ...this.state,
              showReferralError: true,
              referralErrorClass: 'error',
            });
          } else {
            this.setState({
              ...this.state,
              registrationButton: 'Submit Application',
              referralAgentId: referralId,
              showReferralError: false,
              referralErrorClass: 'success',
            });
          }
        })
        .catch((error) => {
          this.setState({
            ...this.state,
            registrationButton: 'Submit Application',
            referralAgentId: '',
            showReferralError: false,
            referralErrorClass: 'success',
          });
          return toast(this.$f7.toast, {
            text:
              'Something went wrong validating referral code. Please re-enter code or reload the page',
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
        });
    }
  }

  selectedLanguages(value, text) {
    this.setState({
      ...this.state,
      [this.state.which]: {
        ...this.state[this.state.which],
        businessProfile: {
          ...this.state[this.state.which].businessProfile,
          spokenLanguages: {
            ...this.state[this.state.which].businessProfile.spokenLanguages,
            [text]: value,
          },
        },
      },
    });
  }

  fillForm() {
    const which =
      this.props.f7route.params.id === '1'
        ? 'merchantRegistrationInfo'
        : this.props.f7route.params.id === '2'
        ? 'deliveryRegistrationInfo'
        : 'partnerRegistrationInfo';

    const detailsObject =
      this.props.f7route.params.id === '1'
        ? {
            ...this.props.data.merchants[this.props.auth.uid].businessProfile,
          }
        : this.props.f7route.params.id === '2'
        ? {
            ...this.props.data.delivery[this.props.auth.uid].businessProfile,
          }
        : {
            ...this.props.data.partners[this.props.auth.uid].businessProfile,
          };

    const referralAgentId =
      this.props.f7route.params.id === '1' &&
      this.props.data.merchants[this.props.auth.uid].referralAgentId
        ? this.props.data.merchants[this.props.auth.uid].referralAgentId
        : this.props.f7route.params.id === '2' &&
          this.props.data.delivery[this.props.auth.uid].referralAgentId
        ? this.props.data.delivery[this.props.auth.uid].referralAgentId
        : '';

    const details =
      this.props.f7route.params.id === '1'
        ? {
            slogan: detailsObject.slogan,
            name: detailsObject.name,
            phone: detailsObject.phone,
            email: detailsObject.email,
            country: detailsObject.country,
            category: detailsObject.category,
            ownsDelivery: detailsObject.ownsDelivery,
            operationStartTime: detailsObject.operationStartTime,
            operationCloseTime: detailsObject.operationCloseTime,
          }
        : this.props.f7route.params.id === '2'
        ? {
            slogan: detailsObject.slogan,
            name: detailsObject.name,
            phone: detailsObject.phone,
            email: detailsObject.email,
            country: detailsObject.country,
            category: detailsObject.category,
            operationStartTime: detailsObject.operationStartTime,
            operationCloseTime: detailsObject.operationCloseTime,
            fleetNumber: detailsObject.fleetNumber,
          }
        : {
            name: detailsObject.name,
            phone: detailsObject.phone,
            email: detailsObject.email,
            country: detailsObject.country,
            spokenLanguages: detailsObject.spokenLanguages,
            employed: detailsObject.employed,
            referralId: detailsObject.referralId,
            partnerType: detailsObject.partnerType,
          };

    this.setState({
      ...this.state,
      [which]:
        which === 'partnerRegistrationInfo'
          ? {
              ...this.state[which],
              businessProfile: {
                ...this.state[which].businessProfile,
                ...details,
              },
            }
          : {
              ...this.state[which],
              referralAgentId,
              businessProfile: {
                ...this.state[which].businessProfile,
                ...details,
              },
            },
    });
  }

  register() {
    this.setState({
      ...this.state,
      registrationButton: 'Processing...',
    });

    let details = this.state[this.state.which];
    let error = false;

    // Validate Fields
    for (const detail of Object.keys(details)) {
      if (detail === 'businessProfile') {
        for (const key of Object.keys(details.businessProfile)) {
          let text;
          switch (key) {
            case 'name':
              text = `What's your ${
                this.state.type == 3 ? '' : "company's"
              } name?`;
              break;
            case 'address':
              text = `What's your ${
                this.state.type == 3 ? '' : "company's"
              } address?`;
              break;
            case 'phone':
              text = `What's your ${
                this.state.type == 3 ? '' : "company's"
              } phone number?`;
              break;
            case 'state':
              text = `What state are you located in?`;
              break;
            case 'city':
              text = `What city are you located in?`;
              break;
            case 'email':
              text = `What's your ${
                this.state.type == 3 ? '' : "company's"
              } email address?`;
              break;
            default:
              text = 'Missing fields please fill all';
          }

          if (
            key === 'geoLoc' &&
            (details.businessProfile[key].lat === '' ||
              details.businessProfile[key].lng === '')
          ) {
            error = true;
            this.setState({
              ...this.state,
              registrationButton: 'Submit Application',
            });
            return toast(this.$f7.toast, {
              text: 'Please use the map to provide your co-ordinates',
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          }

          if (
            key !== 'geoLoc' &&
            key !== 'slogan' &&
            key !== 'spokenLanguages' &&
            key !== 'discovery' &&
            isEmpty(details.businessProfile[key])
          ) {
            error = true;
            this.setState({
              ...this.state,
              registrationButton: 'Submit Application',
            });
            return toast(this.$f7.toast, {
              text,
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          }

          if (key === 'phone') {
            if (
              parseInt(details.businessProfile[key]).toString().length !== 10 ||
              details.businessProfile[key].length !== 11
            ) {
              error = true;
              this.setState({
                ...this.state,
                registrationButton: 'Submit Application',
              });
              return toast(this.$f7.toast, {
                text: 'Invalid phone number',
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            }
          }
          if (key === 'email') {
            if (!isValidEmail(details.businessProfile[key])) {
              error = true;
              this.setState({
                ...this.state,
                registrationButton: 'Submit Application',
              });
              return toast(this.$f7.toast, {
                text: 'Please provide a valid email address',
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            }
          }
        }
      } else {
        const text =
          detail === 'businessLogo'
            ? this.state.type == 3
              ? 'Profile Picture'
              : 'Business Logo'
            : detail === 'certificate1'
            ? 'Business Certificate'
            : 'Identity card';

        if (!details[detail]) {
          error = true;
          this.setState({
            ...this.state,
            registrationButton: 'Submit Application',
          });
          return toast(this.$f7.toast, {
            text: `Upload ${text}`,
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
        }

        if (
          !['image/jpg', 'image/png', 'image/jpeg'].includes(
            details[detail].type
          )
        ) {
          error = true;
          this.setState({
            ...this.state,
            registrationButton: 'Submit Application',
          });
          return toast(this.$f7.toast, {
            text: `${text} should be a valid image`,
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
        }

        if (details[detail].size > 10000000) {
          error = true;
          this.setState({
            ...this.state,
            registrationButton: 'Submit Application',
          });
          return toast(this.$f7.toast, {
            text: `${text} should be below 10MB`,
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
        }
      }
    }

    if (!error) {
      let collection =
        this.state.which === 'merchantRegistrationInfo'
          ? 'merchants'
          : this.state.which === 'deliveryRegistrationInfo'
          ? 'delivery'
          : 'partners';

      this.props.firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((idToken) => {
          axios
            .all([
              isAllowedVendorsAndAgents({
                token: idToken,
                uid: this.props.auth.uid,
                details: {
                  collection,
                  value: details.businessProfile.phone,
                  property: 'phone',
                },
              }),
              isAllowedVendorsAndAgents({
                token: idToken,
                uid: this.props.auth.uid,
                details: {
                  collection,
                  value: details.businessProfile.email,
                  property: 'email',
                },
              }),
            ])
            .then(
              axios.spread((...resArray) => {
                // do this if user wants to resubmit for approval
                if (
                  this.props.data[collection] &&
                  this.props.data[collection][this.props.auth.uid]
                ) {
                  if (collection === 'partners') {
                    deleteFiles(
                      this.props.storage,
                      this.props.data[collection][this.props.auth.uid]
                        .businessProfile.images.certificate2.path,
                      (error, success) => {
                        if (
                          error &&
                          error.code !== 'storage/object-not-found'
                        ) {
                          this.setState({
                            ...this.state,
                            registrationButton: 'Submit Application',
                          });
                          return toast(this.$f7.toast, {
                            text: handleErrors(error),
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        }

                        deleteFiles(
                          this.props.storage,
                          this.props.data[collection][this.props.auth.uid]
                            .businessProfile.images.logo.path,
                          (error, success) => {
                            if (
                              error &&
                              error.code !== 'storage/object-not-found'
                            ) {
                              this.setState({
                                ...this.state,
                                registrationButton: 'Submit Application',
                              });
                              return toast(this.$f7.toast, {
                                text: handleErrors(error),
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }

                            this.setState({
                              ...this.state,
                              registrationButton:
                                this.state.type == 3
                                  ? 'Uploading Profile Picture...'
                                  : 'Uploading Business Logo...',
                            });

                            uploadFile(
                              this.props.storage,
                              'partners',
                              this.props.auth.uid,
                              details.businessLogo,
                              (error, imageObject) => {
                                if (error) {
                                  this.setState({
                                    ...this.state,
                                    registrationButton: 'Submit Application',
                                  });
                                  return toast(this.$f7.toast, {
                                    text: handleErrors(error),
                                    position: 'bottom',
                                    horizontalPosition: 'center',
                                    closeButton: true,
                                    cssClass: 'custom-toast',
                                    closeTimeout: 4000,
                                  });
                                }

                                details.images = {
                                  logo: imageObject,
                                };

                                this.setState({
                                  ...this.state,
                                  registrationButton: 'Uploading Valid ID...',
                                });

                                uploadFile(
                                  this.props.storage,
                                  'identity',
                                  this.props.auth.uid,
                                  details.certificate2,
                                  (error, imageObject) => {
                                    if (error) {
                                      this.setState({
                                        ...this.state,
                                        registrationButton:
                                          'Submit Application',
                                      });
                                      return toast(this.$f7.toast, {
                                        text: handleErrors(error),
                                        position: 'bottom',
                                        horizontalPosition: 'center',
                                        closeButton: true,
                                        cssClass: 'custom-toast',
                                        closeTimeout: 4000,
                                      });
                                    }

                                    details.images = {
                                      ...details.images,
                                      certificate2: imageObject,
                                    };

                                    this.setState({
                                      ...this.state,
                                      registrationButton:
                                        "You'll be all set in a minute",
                                    });

                                    let toUpload = {
                                      approved: false,
                                      accountStatus: 'Pending',
                                      timestamp: Date.now(),
                                      reason: null,
                                      businessProfile: {
                                        ...details.businessProfile,
                                        name: details.businessProfile.name.trim(),
                                        images: {
                                          ...details.images,
                                        },
                                      },
                                    };

                                    let v = 'partners';

                                    this.props.firestore
                                      .collection(v)
                                      .doc(this.props.auth.uid)
                                      .update(toUpload)
                                      .then((doc) => {
                                        this.props.firestore
                                          .collection('users')
                                          .doc(this.props.auth.uid)
                                          .update({
                                            [v]: true,
                                          })
                                          .then(() => {
                                            this.setState({
                                              ...this.state,
                                              registrationButton:
                                                'Submit Application',
                                            });
                                            //go to partners dashboard

                                            this.$f7.views.account.router.navigate(
                                              '/partners/',
                                              {
                                                reloadCurrent: true,
                                              }
                                            );
                                          })
                                          .catch((error) => {
                                            this.setState({
                                              ...this.state,
                                              registrationButton:
                                                'Submit Application',
                                            });
                                            return toast(this.$f7.toast, {
                                              text: handleErrors(error),
                                              position: 'bottom',
                                              horizontalPosition: 'center',
                                              closeButton: true,
                                              cssClass: 'custom-toast',
                                              closeTimeout: 4000,
                                            });
                                          });
                                      })
                                      .catch((error) => {
                                        this.setState({
                                          ...this.state,
                                          registrationButton:
                                            'Submit Application',
                                        });
                                        return toast(this.$f7.toast, {
                                          text: handleErrors(error),
                                          position: 'bottom',
                                          horizontalPosition: 'center',
                                          closeButton: true,
                                          cssClass: 'custom-toast',
                                          closeTimeout: 4000,
                                        });
                                      });
                                  }
                                );
                              }
                            );
                          }
                        );
                      }
                    );
                  } else {
                    deleteFiles(
                      this.props.storage,
                      this.props.data[collection][this.props.auth.uid]
                        .businessProfile.images.certificate1.path,
                      (error, success) => {
                        if (
                          error &&
                          error.code !== 'storage/object-not-found'
                        ) {
                          this.setState({
                            ...this.state,
                            registrationButton: 'Submit Application',
                          });
                          return toast(this.$f7.toast, {
                            text: handleErrors(error),
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        }

                        deleteFiles(
                          this.props.storage,
                          this.props.data[collection][this.props.auth.uid]
                            .businessProfile.images.certificate2.path,
                          (error, success) => {
                            if (
                              error &&
                              error.code !== 'storage/object-not-found'
                            ) {
                              this.setState({
                                ...this.state,
                                registrationButton: 'Submit Application',
                              });
                              return toast(this.$f7.toast, {
                                text: handleErrors(error),
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }

                            deleteFiles(
                              this.props.storage,
                              this.props.data[collection][this.props.auth.uid]
                                .businessProfile.images.logo.path,
                              (error, success) => {
                                if (
                                  error &&
                                  error.code !== 'storage/object-not-found'
                                ) {
                                  this.setState({
                                    ...this.state,
                                    registrationButton: 'Submit Application',
                                  });
                                  return toast(this.$f7.toast, {
                                    text: handleErrors(error),
                                    position: 'bottom',
                                    horizontalPosition: 'center',
                                    closeButton: true,
                                    cssClass: 'custom-toast',
                                    closeTimeout: 4000,
                                  });
                                }

                                this.setState({
                                  ...this.state,
                                  registrationButton:
                                    'Uploading Business Logo...',
                                });

                                uploadFile(
                                  this.props.storage,
                                  'businesslogo',
                                  this.props.auth.uid,
                                  details.businessLogo,
                                  (error, imageObject) => {
                                    if (error) {
                                      this.setState({
                                        ...this.state,
                                        registrationButton:
                                          'Submit Application',
                                      });
                                      return toast(this.$f7.toast, {
                                        text: handleErrors(error),
                                        position: 'bottom',
                                        horizontalPosition: 'center',
                                        closeButton: true,
                                        cssClass: 'custom-toast',
                                        closeTimeout: 4000,
                                      });
                                    }

                                    details.images = {
                                      logo: imageObject,
                                    };

                                    this.setState({
                                      ...this.state,
                                      registrationButton:
                                        'Uploading Business Certificate...',
                                    });

                                    uploadFile(
                                      this.props.storage,
                                      'certificate',
                                      this.props.auth.uid,
                                      details.certificate1,
                                      (error, imageObject) => {
                                        if (error) {
                                          this.setState({
                                            ...this.state,
                                            registrationButton:
                                              'Submit Application',
                                          });
                                          return toast(this.$f7.toast, {
                                            text: handleErrors(error),
                                            position: 'bottom',
                                            horizontalPosition: 'center',
                                            closeButton: true,
                                            cssClass: 'custom-toast',
                                            closeTimeout: 4000,
                                          });
                                        }

                                        details.images = {
                                          ...details.images,
                                          certificate1: imageObject,
                                        };

                                        this.setState({
                                          ...this.state,
                                          registrationButton:
                                            'Uploading Valid ID...',
                                        });

                                        uploadFile(
                                          this.props.storage,
                                          'identity',
                                          this.props.auth.uid,
                                          details.certificate2,
                                          (error, imageObject) => {
                                            if (error) {
                                              this.setState({
                                                ...this.state,
                                                registrationButton:
                                                  'Submit Application',
                                              });
                                              return toast(this.$f7.toast, {
                                                text: handleErrors(error),
                                                position: 'bottom',
                                                horizontalPosition: 'center',
                                                closeButton: true,
                                                cssClass: 'custom-toast',
                                                closeTimeout: 4000,
                                              });
                                            }

                                            details.images = {
                                              ...details.images,
                                              certificate2: imageObject,
                                            };

                                            this.setState({
                                              ...this.state,
                                              registrationButton:
                                                "You'll be all set in a minute",
                                            });

                                            let toUpload = {
                                              approved: false,
                                              accountStatus: 'Pending',
                                              timestamp: Date.now(),
                                              currentStatus: 'online',
                                              ratings: [],
                                              reason: null,
                                              referralAgentId:
                                                this.state.referralAgentId ===
                                                ''
                                                  ? null
                                                  : this.state.referralAgentId,
                                              businessProfile: {
                                                ...details.businessProfile,
                                                name: details.businessProfile.name.trim(),
                                                operationDays: [],
                                                images: {
                                                  ...details.images,
                                                },
                                              },
                                            };

                                            let v =
                                              this.state.which ===
                                              'merchantRegistrationInfo'
                                                ? 'merchant'
                                                : 'deliveryServices';
                                            this.props.firestore
                                              .collection(collection)
                                              .doc(this.props.auth.uid)
                                              .update(toUpload)
                                              .then((doc) => {
                                                this.props.firestore
                                                  .collection('users')
                                                  .doc(this.props.auth.uid)
                                                  .update({
                                                    [v]: true,
                                                  })
                                                  .then(() => {
                                                    this.setState({
                                                      ...this.state,
                                                      registrationButton:
                                                        'Submit Application',
                                                    });
                                                    //go to merchant or delivery dashboard
                                                    let navigateTo =
                                                      this.state.which ===
                                                      'merchantRegistrationInfo'
                                                        ? '/merchant/'
                                                        : '/delivery/';

                                                    if (
                                                      parseInt(
                                                        window.innerWidth
                                                      ) <= 800
                                                    ) {
                                                      this.$f7.views.account.router.back(
                                                        navigateTo,
                                                        {
                                                          force: true,
                                                        }
                                                      );
                                                    } else {
                                                      this.$f7.views.account.router.navigate(
                                                        navigateTo,
                                                        {
                                                          reloadPevious: true,
                                                        }
                                                      );

                                                      this.$f7.views.account.router.back();
                                                    }
                                                  })
                                                  .catch((error) => {
                                                    this.setState({
                                                      ...this.state,
                                                      registrationButton:
                                                        'Submit Application',
                                                    });
                                                    return toast(
                                                      this.$f7.toast,
                                                      {
                                                        text: handleErrors(
                                                          error
                                                        ),
                                                        position: 'bottom',
                                                        horizontalPosition:
                                                          'center',
                                                        closeButton: true,
                                                        cssClass:
                                                          'custom-toast',
                                                        closeTimeout: 4000,
                                                      }
                                                    );
                                                  });
                                              })
                                              .catch((error) => {
                                                this.setState({
                                                  ...this.state,
                                                  registrationButton:
                                                    'Submit Application',
                                                });
                                                return toast(this.$f7.toast, {
                                                  text: handleErrors(error),
                                                  position: 'bottom',
                                                  horizontalPosition: 'center',
                                                  closeButton: true,
                                                  cssClass: 'custom-toast',
                                                  closeTimeout: 4000,
                                                });
                                              });
                                          }
                                        );
                                      }
                                    );
                                  }
                                );
                              }
                            );
                          }
                        );
                      }
                    );
                  }
                } else {
                  this.setState({
                    ...this.state,
                    registrationButton:
                      this.state.type == 3
                        ? 'Uploading Profile Picture...'
                        : 'Uploading Business Logo...',
                  });

                  if (this.state.type == 3) {
                    uploadFile(
                      this.props.storage,
                      'partners',
                      this.props.auth.uid,
                      details.businessLogo,
                      (error, imageObject) => {
                        if (error) {
                          this.setState({
                            ...this.state,
                            registrationButton: 'Submit Application',
                          });
                          return toast(this.$f7.toast, {
                            text: handleErrors(error),
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        }

                        details.images = {
                          logo: imageObject,
                        };

                        this.setState({
                          ...this.state,
                          registrationButton: 'Uploading Valid ID...',
                        });

                        uploadFile(
                          this.props.storage,
                          'identity',
                          this.props.auth.uid,
                          details.certificate2,
                          (error, imageObject) => {
                            if (error) {
                              this.setState({
                                ...this.state,
                                registrationButton: 'Submit Application',
                              });
                              return toast(this.$f7.toast, {
                                text: handleErrors(error),
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }

                            details.images = {
                              ...details.images,
                              certificate2: imageObject,
                            };

                            this.setState({
                              ...this.state,
                              registrationButton:
                                "You'll be all set in a minute",
                            });

                            let toUpload = {
                              approved: false,
                              accountStatus: 'Pending',
                              timestamp: Date.now(),
                              walletId: generateId(7),
                              businessProfile: {
                                ...details.businessProfile,
                                name: details.businessProfile.name.trim(),
                                images: {
                                  ...details.images,
                                },
                              },
                            };

                            let v = 'partners';

                            this.props.firestore
                              .collection(v)
                              .doc(this.props.auth.uid)
                              .set(toUpload)
                              .then((doc) => {
                                this.props.firestore
                                  .collection('users')
                                  .doc(this.props.auth.uid)
                                  .update({
                                    [v]: true,
                                  })
                                  .then(() => {
                                    this.setState({
                                      ...this.state,
                                      registrationButton: 'Submit Application',
                                    });
                                    //go to partners dashboard

                                    this.$f7.views.account.router.navigate(
                                      '/partners/',
                                      {
                                        reloadCurrent: true,
                                      }
                                    );
                                  })
                                  .catch((error) => {
                                    this.setState({
                                      ...this.state,
                                      registrationButton: 'Submit Application',
                                    });
                                    return toast(this.$f7.toast, {
                                      text: handleErrors(error),
                                      position: 'bottom',
                                      horizontalPosition: 'center',
                                      closeButton: true,
                                      cssClass: 'custom-toast',
                                      closeTimeout: 4000,
                                    });
                                  });
                              })
                              .catch((error) => {
                                this.setState({
                                  ...this.state,
                                  registrationButton: 'Submit Application',
                                });
                                return toast(this.$f7.toast, {
                                  text: handleErrors(error),
                                  position: 'bottom',
                                  horizontalPosition: 'center',
                                  closeButton: true,
                                  cssClass: 'custom-toast',
                                  closeTimeout: 4000,
                                });
                              });
                          }
                        );
                      }
                    );
                  } else {
                    uploadFile(
                      this.props.storage,
                      'businesslogo',
                      this.props.auth.uid,
                      details.businessLogo,
                      (error, imageObject) => {
                        if (error) {
                          this.setState({
                            ...this.state,
                            registrationButton: 'Submit Application',
                          });
                          return toast(this.$f7.toast, {
                            text: handleErrors(error),
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        }

                        details.images = {
                          logo: imageObject,
                        };

                        this.setState({
                          ...this.state,
                          registrationButton:
                            'Uploading Business Certificate...',
                        });

                        uploadFile(
                          this.props.storage,
                          'certificate',
                          this.props.auth.uid,
                          details.certificate1,
                          (error, imageObject) => {
                            if (error) {
                              this.setState({
                                ...this.state,
                                registrationButton: 'Submit Application',
                              });
                              return toast(this.$f7.toast, {
                                text: handleErrors(error),
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }

                            details.images = {
                              ...details.images,
                              certificate1: imageObject,
                            };

                            this.setState({
                              ...this.state,
                              registrationButton: 'Uploading Valid ID...',
                            });

                            uploadFile(
                              this.props.storage,
                              'identity',
                              this.props.auth.uid,
                              details.certificate2,
                              (error, imageObject) => {
                                if (error) {
                                  this.setState({
                                    ...this.state,
                                    registrationButton: 'Submit Application',
                                  });
                                  return toast(this.$f7.toast, {
                                    text: handleErrors(error),
                                    position: 'bottom',
                                    horizontalPosition: 'center',
                                    closeButton: true,
                                    cssClass: 'custom-toast',
                                    closeTimeout: 4000,
                                  });
                                }

                                details.images = {
                                  ...details.images,
                                  certificate2: imageObject,
                                };

                                this.setState({
                                  ...this.state,
                                  registrationButton:
                                    "You'll be all set in a minute",
                                });

                                let toUpload = {
                                  approved: false,
                                  accountStatus: 'Pending',
                                  timestamp: Date.now(),
                                  currentStatus: 'online',
                                  ratings: [],
                                  walletId: generateId(7),
                                  referralAgentId:
                                    this.state.referralAgentId === ''
                                      ? null
                                      : this.state.referralAgentId,
                                  businessProfile: {
                                    ...details.businessProfile,
                                    name: details.businessProfile.name.trim(),
                                    operationDays: [],
                                    images: {
                                      ...details.images,
                                    },
                                  },
                                };

                                let v =
                                  this.state.which ===
                                  'merchantRegistrationInfo'
                                    ? 'merchant'
                                    : 'deliveryServices';
                                this.props.firestore
                                  .collection(collection)
                                  .doc(this.props.auth.uid)
                                  .set(toUpload)
                                  .then((doc) => {
                                    this.props.firestore
                                      .collection('users')
                                      .doc(this.props.auth.uid)
                                      .update({
                                        [v]: true,
                                      })
                                      .then(() => {
                                        this.setState({
                                          ...this.state,
                                          registrationButton:
                                            'Submit Application',
                                        });
                                        //go to merchant or delivery dashboard
                                        let navigateTo =
                                          this.state.which ===
                                          'merchantRegistrationInfo'
                                            ? '/merchant/'
                                            : '/delivery/';
                                        this.$f7.views.account.router.navigate(
                                          navigateTo,
                                          {
                                            reloadCurrent: true,
                                          }
                                        );
                                      })
                                      .catch((error) => {
                                        this.setState({
                                          ...this.state,
                                          registrationButton:
                                            'Submit Application',
                                        });
                                        return toast(this.$f7.toast, {
                                          text: handleErrors(error),
                                          position: 'bottom',
                                          horizontalPosition: 'center',
                                          closeButton: true,
                                          cssClass: 'custom-toast',
                                          closeTimeout: 4000,
                                        });
                                      });
                                  })
                                  .catch((error) => {
                                    this.setState({
                                      ...this.state,
                                      registrationButton: 'Submit Application',
                                    });
                                    return toast(this.$f7.toast, {
                                      text: handleErrors(error),
                                      position: 'bottom',
                                      horizontalPosition: 'center',
                                      closeButton: true,
                                      cssClass: 'custom-toast',
                                      closeTimeout: 4000,
                                    });
                                  });
                              }
                            );
                          }
                        );
                      }
                    );
                  }
                }
              })
            )
            .catch((error) => {
              if (error.response) {
                toast(this.$f7.toast, {
                  text: error.response.data.message,
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              } else if (error.request) {
                toast(this.$f7.toast, {
                  text: error.request,
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              } else {
                // Something happened in setting up the request that triggered an Error
                toast(this.$f7.toast, {
                  text: error.message,
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              }
              return this.setState({
                ...this.state,
                registrationButton: 'Submit Application',
              });
            });
        })
        .catch((error) => {
          toast(this.$f7.toast, {
            text: handleErrors(error),
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
          return this.setState({
            ...this.state,
            registrationButton: 'Submit Application',
          });
        });
    }
  }
}

const mapStateToProps = ({ firebase: { auth }, DB: { docs } }) => ({
  auth,
  data: docs,
});

const enhance = compose(
  withStorage,
  withFirestore,
  firestoreConnect((props) => [
    new Doc('merchants', props.auth.uid),
    new Doc('delivery', props.auth.uid),
    new Doc('partners', props.auth.uid),
  ]),
  connect(mapStateToProps)
);

export default enhance(BusinessRegistration);
